import styled from "@emotion/styled";
import Background from '../../../assets/background.jpg';
import { themeColor } from "../../layout/global-style"
import { a } from 'react-spring'

export const Container = styled(a.div)`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-flow: row wrap;
  width: 100%;
  flex: 1 0 100%;
  background-image: url(${Background});
  background-repeat: no-repeat;
  background-position: bottom center;
  background-size: cover;
  background-attachment: fixed;
  z-index: 1; 
  pointer-events: all;

  height: 100%;
  position: absolute;
  top:0;
  min-height: 100%;
  overflow-y: auto;
  background-color: ${themeColor.white};

  @media screen and (orientation: portrait) {
    overflow:auto;
    -webkit-overflow-scrolling:touch;
    
  }

  @media screen and (max-height: 300px) {
    overflow-y: auto;
  }
`

export const Wrapper = styled.div`
  max-width: 1920px;
  margin: 0 auto;
  display: flex;
  width: 100%;
  position: relative;
  align-items: flex-start;
  justify-content: center;
  min-height: 100%;
  flex-flow: row wrap;
`;


export const Content = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-flow: row wrap;
  flex-direction: column;
  color: #${themeColor.black};
  position: relative;
  z-index: 0;
  margin-bottom: 128px;
  margin-top: 40px;
  gap: 54px;

  @media screen and (max-width: 768px){
    gap: 12px;
    margin-top: 106px;
  }
`

export const ListContainer = styled.div`
  display: flex;
 
  align-items: flex-start;
  justify-content: center;
  flex: 1 0 100%;
  width: 100%;
  flex-flow: row wrap;
  align-items: center;
  padding: 0px 0px 40px;
  gap: 24px 32px;

  max-width: 1112px;

  @media screen and (max-width: 768px){
    gap: 10px 32px;
    max-width: 400px;
  }
`
export const Header = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0px;
  gap: 20px;

  @media screen and (max-width: 768px){
    padding: 0px 24px;
    gap: 12px;
  }
`;

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0px;
  gap: 8px;

  @media screen and (max-width: 768px){
    gap: none;
    padding: 0px 0px 16px;

  }

  h1 {
    font-size: 90px;
    line-height: 90px;
    display: flex;
    align-items: center;
    text-align: center;
    text-transform: uppercase;
    margin: 0;

    @media screen and (max-width: 768px){
      font-size: 52px;
      line-height: 52px;
    }
  }

  p {
    font-size: 24px;
    line-height: 30px;
    display: flex;
    align-items: center;
    text-align: center;
    margin: 0;

    @media screen and (max-width: 768px){
      font-size: 18px;
      line-height: 28px;
    }
  }
`;

export const LogoContainer = styled.div`
    display: flex;
    img {
      height: 64px;
    }
    @media screen and (max-width: 768px){
      img {
        height: 40px;
      }
    }
`;

export const PageChunkContainer = styled.div`
    display: flex;
    flex: 0 0 20%;

    flex-direction: row;
    justify-content: center;
    align-items: flex-start;
    padding: 0px;
`;

export const PageContainer = styled.div`
    display: flex;
    position: relative;
    flex-direction:column;
    margin: 0;
    width: 254px;

    display: flex;
    flex-direction: column;
    padding: 0px;
    gap: 4px;

    @media screen and (max-width: 768px){
      width: 128px;
    }
`;

export const PageThumbnail = styled.img`
  margin: 0;
`;

export const PageThumbnailBorder = styled.div`
  position: relative;
  margin: 0; 
  padding: 0;
  padding-top: calc(150% + 2px);
  &::after{
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border: 1px solid;
    border-width: ${ (props) => props.current ? 3 : 1 }px; 
    border-left: ${ (props) => props.noLeftBorder ? 'none' : undefined };
    border-right: ${ (props) => props.noRightBorder ? 'none' : undefined };
    border-color: ${ (props) => props.hover || props.current ? themeColor.red : themeColor.black }; 
    z-index: 1;
  }
  img {
    position: absolute;
    top: 0;
    left: 0;
  }
`;

export const PageLabel = styled.span`
  font-family: ff-good-web-pro-condensed, sans-serif;
  text-transform: uppercase;
  color: ${ (props) => props.hover || props.current ? themeColor.red : themeColor.black }; 
  align-self: center;
  display: flex;
  font-size: 18px;
  line-height: 28px;
`;
